import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'

class AssessmentsComparison extends Component {
  formatScore = (score, interpretation) => {
    const displayScore =
      score !== null && score !== undefined ? score : '—'

    return `${displayScore} [${interpretation || 'Not available'}]`
  }

  calculateChange = (latest, comparison) => {
    if (
      latest === null ||
      latest === undefined ||
      comparison === null ||
      comparison === undefined
    ) {
      return null
    }

    return latest - comparison
  }

  formatChange = change => {
    if (change === null || change === undefined) {
      return '—'
    }

    if (change > 0) {
      return `+${change}`
    }

    return change
  }

  getAssessmentComparison = () => {
    return[
      {
        assessment: 'Depression',

        baseline: 21,
        baselineInterpretation:
          'Severe',

        previous: 17,
        previousInterpretation:
          'Moderately severe',
        previousTimepoint: 'Monthly 11',

        latest: 18,
        latestInterpretation:
          'Moderately severe',
        latestTimepoint: 'Monthly 12',
        baselineChange: 'Improved',
        recentChange: 'Stable',
      },
      {
        assessment: 'Mania',

        baseline: 11,
        baselineInterpretation:
          '(hypo)mania',

        previous: 12,
        previousInterpretation:
          '(hypo)mania',
        previousTimepoint: 'Monthly 11',

        latest: 13,
        latestInterpretation:
          '(hypo)mania',
        latestTimepoint: 'Monthly 12',
        baselineChange: 'Stable',
        recentChange: 'Stable',
      },
      {
        assessment: 'Anxiety',

        baseline: 21,
        baselineInterpretation:
          'Severe anxiety',

        previous: 17,
        previousInterpretation:
          'Severe anxiety',
        previousTimepoint: 'Monthly 11',

        latest: 17,
        latestInterpretation:
          'Severe anxiety',
        latestTimepoint: 'Monthly 12',
        baselineChange: 'Stable',
        recentChange: 'Stable',
      },
      // 0-5: Generally good sleep quality, 6-21: Significant sleep difficulties
      {
        assessment: 'Sleep',

        baseline: 16,
        baselineInterpretation:
          'Significant sleep difficulties',

        previous: 21,
        previousInterpretation:
          'Significant sleep difficulties',
        previousTimepoint: 'Monthly 11',

        latest: 20,
        latestInterpretation:
          'Significant sleep difficulties',
        latestTimepoint: 'Monthly 12',
        baselineChange: 'Worsened',
        recentChange: 'Stable',
      },
      {
        assessment: 'Well-being',

        baseline: null,
        baselineInterpretation:
          'Not available',

        previous: 5,
        previousInterpretation:
          'Poor well-being',
        previousTimepoint: 'Monthly 11',

        latest: 4,
        latestInterpretation:
          'Poor well-being',
        latestTimepoint: 'Monthly 12',
        baselineChange: '-',
        recentChange: 'Stable',
      },
      // 18-54: Lower range of psychological well-being, 55-90: Middle range of psychological well-being, 91-126: Higher range of psychological well-being
      /*{
        assessment: 'PWS/PW18',

        baseline: 44,
        baselineInterpretation: 'Lower range of psychological well-being',

        previous: 68,
        previousInterpretation: 'Middle range of psychological well-being',
        previousTimepoint: 'Tri-monthly 3',

        latest: 52,
        latestInterpretation: 'Lower range of psychological well-being',
        latestTimepoint: 'Tri-monthly 4',
        baselineChange: 'Improved',
        recentChange: 'Worsened',
      },
      // 18–42: Fewer difficulties managing emotions, 43–90: More difficulties managing emotions
      {
        assessment: 'DERS-18',

        baseline: 78,
        baselineInterpretation:
          'More difficulties managing emotions',

        previous: 75,
        previousInterpretation:
          'More difficulties managing emotions',
        previousTimepoint: 'Six-monthly 1',

        latest: 64,
        latestInterpretation:
          'More difficulties managing emotions',
        latestTimepoint: 'Six-monthly 2',
        baselineChange: 'Stable',
        recentChange: 'Stable',
      },*/
    ]
  }

  render() {
    const assessmentComparison =
      this.getAssessmentComparison()

    return (
      <div className="small-12 columns">
        <div className="title6">
          Assessment Score Comparison
        </div>

        <table>
          <thead>
            <tr>
              <th>Assessment</th>
              <th>Now</th>

              <th>Previous</th>
              <th>At Enrollment</th>
              <th>Change from at enrollment</th>
              <th>Recent Change</th>
            </tr>
          </thead>

          <tbody>
            {assessmentComparison.map(item => {
              const changeFromBaseline =
                item.latest !== null &&
                item.baseline !== null
                  ? item.latest - item.baseline
                  : null

              const recentChange =
                item.latest !== null &&
                item.previous !== null
                  ? item.latest - item.previous
                  : null

              const formatChange = value => {
                if (value === null) {
                  return '—'
                }

                return value > 0 ? `+${value}` : value
              }

              return (
                <tr key={item.assessment}>
                  <td>{item.assessment}</td>
                  <td>
                    {/*item.latest !== null
                      ? item.latest
                      : '—'}{' '*/}
                    {item.latestInterpretation}
                  </td>


                  <td>
                    {/*item.previous !== null
                      ? item.previous
                      : '—'}{' '*/}
                    {item.previousInterpretation}
                  </td>
                  <td>
                    {/*item.baseline !== null
                      ? item.baseline
                      : '—'}{' '*/}
                    {item.baselineInterpretation}
                  </td>


                  <td>
                    {item.baselineChange}
                  </td>

                  <td>
                    {item.recentChange}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return state
}

const mapDispatchToProps = dispatch => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AssessmentsComparison)
